import React from "react"
import { FormattedMessage } from "react-intl"
import { Link } from "react-router-dom"
import Icon from "../../../icon/icon.component.jsx"

const ProductCreationButton = () => {
    return (
        <>
            <Link to="/imports/products" className="btn btn-outline-primary">
                <Icon value="download" />
                <FormattedMessage
                    id="generic-listing.import-btn-text"
                    defaultMessage="Import"
                />
            </Link>
            <Link to="/products/new" className="btn btn-primary">
                <Icon value="plus-circle" />
                <FormattedMessage
                    id="generic-listing.products.create-btn-text"
                    defaultMessage="New product"
                />
            </Link>
        </>
    )
}

export default ProductCreationButton


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/ProductCreationButton.tsx